import React from 'react'
import PropTypes from 'prop-types'
/* import Success from './Success' */
import Cart from './Cart'
/* import Login from './Login' */
import CheckoutElementContainer from './CheckoutElementContainer'
/* import Signup from './Signup'
 * import StripeReadyCheckout from './StripeReadyCheckout' */
import OrderReview from './OrderReview'

export default class BasePanel extends React.Component {
  static propTypes = {
    leftSide: PropTypes.element.isRequired,
    rightSide: PropTypes.element.isRequired,
  }

  loggedInBanner(loggedInBool) {
    if (loggedInBool) {
      return (
        <div className="text-center bg-blue py-2 maxh-40px col-md-12">
          <small className="text-white font-title">
            Logged in as cw@joedirt.com.
          </small>
        </div>
      )
    } else {
      return
    }
  }

  render() {
    return (
      <div className="row w-100 m-0 minh-600px">
        {this.loggedInBanner(true)}
        <div className="col-md-6 order-md-2 px-0 bg-light-gray">
          <CheckoutElementContainer
            element={<Cart />}
            title={'Shopping Cart'}
            bold={false}
          />
        </div>
        <div className="col-md-6 order-md-1 px-0 bg-white">
          <CheckoutElementContainer
            element={<OrderReview />}
            title={'Review Order'}
            bold
          />
        </div>
      </div>
    )
  }
}
